<template>
  <v-card class="ma-3" style="min-height:100%;" :width="newWidth">
    <h3 class="py-3 pl-4">RATINGS</h3>
    <div v-if="ratingData.total > 0">
      <v-layout flex-row class="d-flex align-center pl-5">
        <h1>
          {{
            parseFloat(Math.round(this.ratingData.avg * 100) / 100).toFixed(2)
          }}
        </h1>
        <v-rating
          v-model="ratingData.avg"
          color="primary"
          readonly
          half-increments
          background-color="primary"
          id="rating-stars"
        ></v-rating>
      </v-layout>
      <h3 class="py-3 pl-5">
        Average Rating of &nbsp;{{ ratingData.total }} total ratings
      </h3>
      <v-layout
        v-for="(voteObj, i) in ratingData.votesPerRating"
        :key="i"
        class="d-flex align-center pl-3"
      >
        <div style="width:25%;" class="d-flex justify-end pr-2 pr-md-4 pr-lg-4">
          <v-rating
            v-model="voteObj.rating"
            :length="voteObj.rating"
            readonly
            x-small
            dense
          ></v-rating>
        </div>
        <v-progress-linear
          color="primary"
          rounded
          height="6"
          style="width:50%;"
          :value="getPercentage(voteObj.amount)"
        ></v-progress-linear>

        <h4 class="pl-5" color="primary">{{ voteObj.amount }}</h4>
      </v-layout>
      <!-- <div class="d-flex justify-center pt-4">
        <h3 class="read-click">
          Read Reviews
        </h3>
      </div> -->
    </div>
    <div v-else>
      <h3 class="py-3 pl-5 d-flex">
        No Ratings Were Found For The Time Period Selected.
      </h3>
    </div>
  </v-card>
</template>

<script>
import { card, MobileView } from '@/mixins';

export default {
  name: 'ratings',
  props: ['ratingData', 'width'],
  mixins: [card, MobileView],
  data: () => ({}),
  computed: {
    newWidth() {
      if (this.width && !this.showMobileView) {
        return this.width;
      }
      return this.cardWidth;
    },
    bufferValue() {
      let value = null;
      this.ratingData.votesPerRating.map((rating) => {
        value += rating.amount;
      });
      return value;
    },
  },
  methods: {
    getPercentage(value) {
      return (value / this.bufferValue) * 100;
    },
  },
};
</script>

<style>
.read-click:hover {
  cursor: pointer;
}
</style>
